import {
  CORE_GET_APP_INFO,
  type AppInfoPayload,
} from '@/pwa/bridge-v2/protocol';
import type { Bridge } from './bridge';

// =============================================================================
// bridge.core — bridge-meta surface
// =============================================================================
// "Core" here means *the bridge's own metadata* — environment, transport,
// capabilities, current push-token snapshot. Distinct from `bridge.plugins.*`
// (Capacitor plugin wrappers) and from future `bridge.platform.*` (backend
// API calls to AppEase services like user info / push-token linking).

export interface CoreSurface {
  /** Request a fresh appInfo snapshot from the host. The cached
   *  `bridge.appInfo` accessor returns whatever was most recently
   *  broadcast / fetched; call this explicitly when a refresh is needed
   *  (after a permission grant etc.). */
  getAppInfo(): Promise<AppInfoPayload>;
}

export const buildCore = (b: Bridge): CoreSurface => ({
  getAppInfo: () => b.request<AppInfoPayload>(CORE_GET_APP_INFO),
});
